// menu.config.ts
import { MenuItem } from 'primeng/api';
import { RoleGroups, Roles } from '../../../core/services/conf/permission.service';

export interface MenuItemConfig extends MenuItem {
    allowedRoles?: (Roles | string)[];
}

export const MENU_CONFIG: MenuItemConfig[] = [
    {
        label: 'Inicio',
        items: [
            {
                label: 'Dashboard',
                icon: 'pi pi-fw pi-home',
                allowedRoles: RoleGroups.ADMIN,
                routerLink: ['/sp']
            }
        ]
    },
    {
        label: 'SECCIONES',
        items: [
            {
                label: 'Préstamos',
                icon: 'pi pi-fw pi-check-square',
                allowedRoles: [...RoleGroups.RRHH_ADM, Roles.CONTADOR],
                routerLink: ['/sp/loans']
            },
            {
                label: 'Libro Caja',
                icon: 'pi pi-fw pi-book',
                allowedRoles: [...RoleGroups.RRHH_ADM, Roles.CONTADOR],
                routerLink: ['/sp/cash']
            },
            {
                label: 'Clientes',
                icon: 'pi pi-fw pi-id-card',
                allowedRoles: [...RoleGroups.RRHH_ADM, Roles.CONTADOR],
                routerLink: ['/sp/clients']
            },
            {
                label: 'Facturación',
                icon: 'pi pi-fw pi-receipt',
                allowedRoles: [...RoleGroups.RRHH_ADM, Roles.CONTADOR],
                items: [
                    {
                        label: 'Facturas',
                        icon: 'pi pi-fw pi-receipt',
                        allowedRoles: RoleGroups.RRHH_CONTABILIDAD,
                        routerLink: ['/sp/invoicing/invoice']
                    },
                    {
                        label: 'Recibos',
                        icon: 'pi pi-fw pi-file-pdf',
                        allowedRoles: RoleGroups.RRHH_CONTABILIDAD,
                        routerLink: ['/sp/invoicing/receipt']
                    },
                    {
                        label: 'Notas de Crédito',
                        icon: 'pi pi-fw pi-file-import',
                        allowedRoles: RoleGroups.RRHH_CONTABILIDAD,
                        routerLink: ['/sp/invoicing/creditnote']
                    }
                ]
            },
            {
                label: 'Reportes',
                icon: 'pi pi-fw pi-chart-line',
                allowedRoles: RoleGroups.RRHH_CONTABILIDAD,
                items: [
                    {
                        label: 'Reporte Prestamos',
                        icon: 'pi pi-fw pi-chart-scatter',
                        allowedRoles: RoleGroups.RRHH_CONTABILIDAD,
                        routerLink: ['/sp/reports/loans']
                    },
                    {
                        label: 'Reporte General',
                        icon: 'pi pi-fw pi-chart-bar',
                        allowedRoles: RoleGroups.RRHH_CONTABILIDAD,
                        routerLink: ['/sp/reports/general']
                    },
                    {
                        label: 'Reporte Mensual',
                        icon: 'pi pi-fw pi-chart-pie',
                        allowedRoles: RoleGroups.RRHH_CONTABILIDAD,
                        routerLink: ['/sp/reports/monthly']
                    },
                    {
                        label: 'Cuotas Detallado',
                        icon: 'pi pi-fw pi-chart-line',
                        allowedRoles: RoleGroups.RRHH_CONTABILIDAD,
                        routerLink: ['/sp/reports/quota/detail']
                    },
                    {
                        label: 'Descuento Planilla',
                        icon: 'pi pi-fw pi-percentage',
                        allowedRoles: RoleGroups.RRHH_CONTABILIDAD,
                        items: [
                            {
                                label: 'Pendiente',
                                icon: 'pi pi-fw pi-clock',
                                routerLink: ['/sp/reports/discount/pending']
                            },
                            {
                                label: 'Histórico',
                                icon: 'pi pi-fw pi-history',
                                routerLink: ['/sp/reports/discount/history']
                            }
                        ]
                    }
                ]
            },
            {
                label: 'Calculadora Préstamos',
                icon: 'pi pi-fw pi-wallet',
                allowedRoles: RoleGroups.RRHH_CONTABILIDAD,
                routerLink: ['/sp/calc']
            }
        ]
    },
    {
        label: 'ECOMMERCE',
        allowedRoles: RoleGroups.ECOMMERCE_BASIC,
        items: [
            {
                label: 'Ecommerce',
                icon: 'pi pi-fw pi-cart-plus',
                allowedRoles: RoleGroups.ECOMMERCE_BASIC,
                routerLink: ['/sp/ec/view']
            },
            {
                label: 'Productos',
                icon: 'pi pi-fw pi-tags',
                allowedRoles: RoleGroups.ECOMMERCE,
                routerLink: ['/sp/ec/products/management']
            },
            {
                label: 'Ordenes',
                icon: 'pi pi-fw pi-server',
                allowedRoles: RoleGroups.ECOMMERCE_ADMIN,
                items: [
                    {
                        label: 'Ordenes',
                        icon: 'pi pi-fw pi-credit-card',
                        allowedRoles: RoleGroups.ECOMMERCE_ADMIN,
                        routerLink: ['/sp/ec/orders']
                    },
                    {
                        label: 'Tracking Compras',
                        icon: 'pi pi-fw pi-truck',
                        allowedRoles: RoleGroups.ECOMMERCE_ADMIN,
                        routerLink: ['/sp/ec/orders/tracking']
                    }
                ]
            },
            {
                label: 'Libro Caja',
                icon: 'pi pi-fw pi-book',
                allowedRoles: RoleGroups.ECOMMERCE_ADMIN,
                routerLink: ['/sp/ec/cashbook']
            }
        ]
    },
    {
        label: 'CONFIGURACIONES',
        allowedRoles: RoleGroups.ECOMMERCE_BASIC,
        items: [
            {
                label: 'Categorias',
                icon: 'pi pi-fw pi-th-large',
                allowedRoles: RoleGroups.ECOMMERCE_BASIC,
                routerLink: ['/sp/ec/settings/category']
            },
            {
                label: 'Proveedores',
                icon: 'pi pi-fw pi-warehouse',
                allowedRoles: RoleGroups.ECOMMERCE_BASIC,
                routerLink: ['/sp/ec/settings/supplier']
            }
            // {
            //     label: 'Usuarios',
            //     icon: 'pi pi-fw pi-address-book',
            //     allowedRoles: RoleGroups.FULL_ACCESS,
            //     routerLink: ['/sp/settings/user']
            // }
        ]
    }
];
